import type {Warehouse} from '~/types/legacy'
import type {Populated} from '~/types/populated'

export function useWarehouse() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const result = await sdk.findGlobal({
      slug: 'warehouseGlobal',
      depth: 4,
      draft: !!route.query.preview,
    })

    return result as Populated<Warehouse>
  }

  return {fetch}
}
